import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'

export enum CruisePageCarouselSection {
  Deals = 'deals',
  TopOffers = 'topOffers',
  LuxPlusOffers = 'luxPlusOffers',
  CruiseLines = 'cruiseLines',
  Destinations = 'destinations',
  DepartingFrom = 'departingFrom',
  RoyalCaribbean = 'royalCaribbean',
  Departures = 'departures',
  ShortTerm = 'shortTerm',
  LongHaulOcean = 'longHaulOcean',
  LuxuryPremium = 'luxuryPremium',
  River = 'river',
  BestValue = 'bestValue',
  Expedition = 'expedition',
  CruiseTour = 'cruiseTour',
}

export const CRUISE_PAGE_CONTROL_CAROUSEL_ORDER: Array<CruisePageCarouselSection> = [
  CruisePageCarouselSection.Deals,
  CruisePageCarouselSection.TopOffers,
  CruisePageCarouselSection.LuxPlusOffers,
  CruisePageCarouselSection.CruiseLines,
  CruisePageCarouselSection.Destinations,
  CruisePageCarouselSection.DepartingFrom,
  CruisePageCarouselSection.RoyalCaribbean,
  CruisePageCarouselSection.Departures,
  CruisePageCarouselSection.ShortTerm,
  CruisePageCarouselSection.LongHaulOcean,
  CruisePageCarouselSection.LuxuryPremium,
  CruisePageCarouselSection.River,
  CruisePageCarouselSection.BestValue,
  CruisePageCarouselSection.Expedition,
  CruisePageCarouselSection.CruiseTour,
]

const CRUISE_PAGE_MEMBER_EXPERIMENT_CAROUSEL_ORDER: Array<CruisePageCarouselSection> = [
  CruisePageCarouselSection.Deals,
  CruisePageCarouselSection.TopOffers,
  CruisePageCarouselSection.LuxPlusOffers,
  CruisePageCarouselSection.Destinations,
  CruisePageCarouselSection.DepartingFrom,
  CruisePageCarouselSection.Departures,
  CruisePageCarouselSection.LongHaulOcean,
  CruisePageCarouselSection.River,
  CruisePageCarouselSection.RoyalCaribbean,
  CruisePageCarouselSection.BestValue,
  CruisePageCarouselSection.LuxuryPremium,
  CruisePageCarouselSection.ShortTerm,
  CruisePageCarouselSection.CruiseLines,
  CruisePageCarouselSection.Expedition,
  CruisePageCarouselSection.CruiseTour,
]

const CRUISE_PAGE_NON_MEMBER_EXPERIMENT_CAROUSEL_ORDER: Array<CruisePageCarouselSection> = [
  CruisePageCarouselSection.Deals,
  CruisePageCarouselSection.TopOffers,
  CruisePageCarouselSection.Destinations,
  CruisePageCarouselSection.DepartingFrom,
  CruisePageCarouselSection.Departures,
  CruisePageCarouselSection.LongHaulOcean,
  CruisePageCarouselSection.River,
  CruisePageCarouselSection.LuxPlusOffers,
  CruisePageCarouselSection.RoyalCaribbean,
  CruisePageCarouselSection.BestValue,
  CruisePageCarouselSection.LuxuryPremium,
  CruisePageCarouselSection.ShortTerm,
  CruisePageCarouselSection.CruiseLines,
  CruisePageCarouselSection.Expedition,
  CruisePageCarouselSection.CruiseTour,
]

interface CruisePageCarouselOrderOptions {
  isExperimentVariant: boolean
  isLuxPlusMember: boolean
}

export function getCruisePageContentOrder({
  isExperimentVariant,
  isLuxPlusMember,
}: CruisePageCarouselOrderOptions): Array<CruisePageCarouselSection> {
  if (!isExperimentVariant) {
    return CRUISE_PAGE_CONTROL_CAROUSEL_ORDER
  }

  return isLuxPlusMember ?
    CRUISE_PAGE_MEMBER_EXPERIMENT_CAROUSEL_ORDER :
    CRUISE_PAGE_NON_MEMBER_EXPERIMENT_CAROUSEL_ORDER
}

export default function useCruisePageContentOrder(): Array<CruisePageCarouselSection> {
  const isLuxPlusMember = useAppSelector(getCanViewLuxPlusBenefits)
  const { isAnyVariant: isCarouselRerankingVariant } = useExperiment(
    Experiments.cruiseLandingPageCarouselRerankingByCtr,
  )

  return getCruisePageContentOrder({
    isExperimentVariant: isCarouselRerankingVariant,
    isLuxPlusMember,
  })
}
